<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar informaci&oacute;n prospecto" : "Nuevo Prospecto"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar del prospecto" : "Completa los datos para registrar un nuevo prospecto"}}</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <h5 class="text-semibold mt-4">Informaci&oacute;n</h5>
            <form #prospectForm="ngForm" (ngSubmit)="$event.preventDefault()">
            <div class="d-grid prospect-form">
                <div>
                    <div class="mt-3">
                        <label class="login-label" for="Estado"><span class="required-asterisk" *ngIf="!request.id_estado || request.id_estado.trim()===''">*</span>Estado del prospecto:</label>
                        <!-- <input class="crm-input" type="text" name="email" id="email"> -->
                         <select class="crm-input" name="estado" id="" [(ngModel)]="request.id_estado" #estadoCtrl="ngModel" required>
                            <option value="" disabled selected>Seleccionar estado del prospecto</option>
                            @for (estado of estados; track estado.id_estado) {
                                <option [value]="estado.id_estado">{{ estado.nombre }}</option>
                            }
                         </select>
                    </div>
                    <div class="mt-3">
                    <label class="login-label">
                        <span class="required-asterisk" *ngIf="!request.nombre">*</span>
                        Nombres:
                    </label>
                    <input 
                        class="crm-input"
                        type="text"
                        name="name"
                        id="name"
                        [value]="prospecto?.nombre"
                        [(ngModel)]="request.nombre"
                        required
                        #nameCtrl="ngModel"
                    >
                    <div class="error-text" *ngIf="nameCtrl.invalid && nameCtrl.touched">
                        <small *ngIf="nameCtrl.errors?.['required']">
                            Debe escribir el nombre del prospecto
                        </small>
                    </div>
                </div>

                    <div class="mt-3">
                        <label class="login-label">
                            <span class="required-asterisk" *ngIf="!request.cargo">*</span>
                             Cargo:
                        </label>
                        <input 
                        class="crm-input" 
                        type="text" 
                        name="cargo" 
                        id="cargo"
                        [value]="prospecto?.cargo"
                        [(ngModel)]="request.cargo"
                        required
                        #cargoCtrl="ngModel">
                        <div class="error-text" *ngIf="cargoCtrl.invalid && cargoCtrl.touched">
                            <small *ngIf="cargoCtrl.errors?.['required']">
                                Debe escribir el cargo del prospecto
                            </small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Sitio web:</label>
                        <input class="crm-input" type="text" name="website" id="website" [value]="prospecto?.sitio_web" [(ngModel)]="request.sitio_web">
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">N&uacute;mero de empleados:</label>
                        <input class="crm-input" type="text" name="empleados" id="empleados" [value]="prospecto?.empleados" [(ngModel)]="request.empleados">
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Tel&eacute;fono</label>
                        <input class="crm-input" type="text" name="telefono" id="telefono" pattern="^\+?\d{0,15}$" inputmode="numeric" title="Ingrese solo números. Ejemplo: +56912345678" [value]="prospecto?.telefono" [(ngModel)]="request.telefono">
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Origen del prospecto:</label>
                        <select class="crm-input" name="origen" id="" [(ngModel)]="request.origen">
                            <option value="Publicidad">Publicidad</option>
                            <option value="Referencia">Referencia</option>
                            <option value="Web">Web</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>
                </div>

                <div>
                    <div class="mt-3">
                        <label class="login-label" for="">Propietario del prospecto:</label>
                        <div class="d-flex flex-row align-items-center color-org gap-10"><img src="assets/svg/avatar.svg" alt=""><b><u>{{ data.mode === 'edit'
                            ? (prospecto?.ejecutivo?.nombre + ' ' + prospecto?.ejecutivo?.apellido || loggedUserName)
                            : loggedUserName
                        }}</u></b></div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label">
                            <span class="required-asterisk" *ngIf="!request.apellido">*</span>
                            Apellidos:
                        </label>
                        <input 
                        class="crm-input" 
                        type="text" 
                        name="apellido" 
                        id="apellido" 
                        [value]="prospecto?.apellido" 
                        [(ngModel)]="request.apellido"
                        required
                        #apellidoCtrl="ngModel">
                        <div class="error-text" *ngIf="apellidoCtrl.invalid && apellidoCtrl.touched">
                            <small *ngIf="apellidoCtrl.errors?.['required']">
                                Debe escribir el apellido del prospecto
                            </small>
                        </div>    
                    </div>
                    <div class="mt-3">
                        <label class="login-label">
                            <span class="required-asterisk" *ngIf="!request.empresa">*</span>
                             Compa&#241;&iacute;a:
                            </label>
                        <input 
                        class="crm-input" 
                        type="text" 
                        name="compania" 
                        id="compania" 
                        [value]="prospecto?.empresa" 
                        [(ngModel)]="request.empresa"
                        required
                        #companiaCtrl="ngModel">
                        <div class="error-text" *ngIf="companiaCtrl.invalid && companiaCtrl.touched">
                            <small *ngIf="companiaCtrl.errors?.['required']">
                                Debe escribir la compa&#241;&iacute;a del prospecto
                            </small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Industria:</label>
                        <select class="crm-input" name="industria" id="" [(ngModel)]="request.industria_id">
                            @for (industry of industrias; track industry) {
                                <option [value]="industry.industria_id">{{ industry.nombre }}</option>
                            }
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Correo:</label>
                        <input class="crm-input" type="text" name="email" id="email" [value]="prospecto?.email" [(ngModel)]="request.email">
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Celular</label>
                        <input class="crm-input" type="text" name="celular" id="celular" pattern="^\+?\d{0,15}$" inputmode="numeric" title="Ingrese solo números. Ejemplo: +56912345678" [value]="prospecto?.celular" [(ngModel)]="request.celular">
                    </div>
                </div>
            </div>

            <h5 class="text-semibold mt-4">Informaci&oacute;n de direcci&oacute;n</h5>
            <div class="mt-3">
                <label class="login-label" for="">B&uacute;squeda de la direcci&oacute;n:</label>
                <input class="crm-input" type="text" name="direccion" id="direccion" [value]="prospecto?.direccion" [(ngModel)]="request.direccion">
            </div>

            <div class="d-grid prospect-form">
                <div>
                    <div class="mt-3">
                        <label class="login-label" for="">Calle</label>
                        <input class="crm-input" type="text" name="calle" id="calle" [value]="prospecto?.calle" [(ngModel)]="request.calle">
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Region</label>
                        <select class="crm-input" name="region" id="" [(ngModel)]="request.region" (change)="getComunas(request.region)">
                            @for(item of regiones; track item.NombreRegion){
                                <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                            }
                        </select>
                    </div>
                </div>

                <div>
                    <div class="mt-3">
                        <label class="login-label" for="">Comuna</label>
                        <select class="crm-input" name="comuna" id="" [(ngModel)]="request.ciudad">
                            @for (comuna of comunas; track comuna) {
                                <option [value]="comuna">{{ comuna }}</option>
                            }
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="">Pa&iacute;s</label>
                        <input class="crm-input" type="text" name="pais" id="pais" [value]="prospecto?.pais" [(ngModel)]="request.pais" disabled>
                    </div>
                </div>
            </div>
            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button type="button" (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                @if(data.mode === 'edit'){
                    <button type="button" class="btn btn-primary text-center" (click)="updateProspect();" [disabled]="!prospectForm.valid">Modificar prospecto</button>
                }@else{
                    <button type="button" class="btn btn-primary text-center" (click)="createProspect();" [disabled]="!prospectForm.valid">A&#241;adir nuevo prospecto</button>
                }
            </div>
            </form>
        </div>
    </div>
</div>  